// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"TodoList_errorMessage__3qCNg","error":"TodoList_error__2k7k2","button":"TodoList_button__2UrSy","todolistTitle":"TodoList_todolistTitle__1tRXl"};